export default {
    payment_methods: state => state.payment_methods,
    all_payment_methods: state => state.all_payment_methods,
    single_payment_method: state => state.single_payment_method
}